module.exports = __webpack_public_path__ + "media/images/case-studies/jindivick-bb501d0a5ced8b22dd6384a88a366153.jpg";